import * as React from "react";

interface Props { message?: string };

export const ErrorMessage = (props: Props) => {
  if (!props.message) { return null; }
  return (
    <div
      className="alert alert-danger"
      role="alert"
    >
      {props.message}
    </div>
  )
}